import React from "react";
import CircularProgress from "../../../components/CircularProgress/CircularProgress";
import style from "./styles.module.scss";

export const LoadingMessage = ({ text, className = "" }) => (
  <div className={`${style.loadingMessage} ${className}`}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export const addMonth = function (date, monthsToAdd) {
  const d = date;
  d.setMonth(d.getMonth() + monthsToAdd);
  return d;
};

export const addDay = function (date, daysToAdd) {
  const d = date;
  d.setDate(d.getDate() + daysToAdd);
  return d;
};

export const getBalanceTypeName = (value) => BalanceTypes.find((type) => type.value == value).name;

export const getBalanceTypeValue = (name) => {
  const v = BalanceTypes.find((type) => type.name == name);
  if (v) return v.value;
  else return BalanceTypes[0].value;
};
export const BalanceTypes = [
  { description: "Current", name: "Current", value: 1 },
  { description: "Custody", name: "Custody", value: 2 },
  { description: "Tax Custody", name: "TaxCustody", value: 3 },
  { description: "Repo", name: "Repo", value: 4 },
  { description: "Margin", name: "Margin", value: 5 },
  { description: "Self Custody", name: "SelfCustody", value: 6 },
  { description: "Warrant", name: "Warrant", value: 7 },
  { description: "Savings", name: "Savings", value: 8 },
  { description: "Local Custody", name: "LocalCustody", value: 9 },
  { description: "Short", name: "Short", value: 10 },
  { description: "COD", name: "COD", value: 11 },
  { description: "Money Market Fund", name: "MoneyMarketFund", value: 12 },
  { description: "Available For Sale", name: "AFS", value: 13 },
  { description: "Hold to Maturity", name: "HTM", value: 14 },
  { description: "Stock T", name: "StockT", value: 15 },
  { description: "Stock O", name: "StockO", value: 16 },
  { description: "Stock U", name: "StockU", value: 17 },
  { description: "Stock I", name: "StockI", value: 18 },
  { description: "Stock S", name: "StockS", value: 19 },
  { description: "Markup", name: "Markup", value: 20 },
  { description: "PendingSet", name: "PendingSet", value: 21 },
  { description: "Collateral", name: "Collateral", value: 22 },
];
